import { render, staticRenderFns } from "./TitleDetail.vue?vue&type=template&id=20dd8244&scoped=true&"
import script from "./TitleDetail.vue?vue&type=script&lang=js&"
export * from "./TitleDetail.vue?vue&type=script&lang=js&"
import style0 from "./TitleDetail.vue?vue&type=style&index=0&id=20dd8244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd8244",
  null
  
)

export default component.exports